import { useMemo } from "react";
import DynamicRadarChart from "./DynamicRadarChart";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SubDimensionCharts = ({ responseBody, myhandleExport, remark }) => {
  // Process data efficiently using useMemo
  const chartData = useMemo(() => {
    return responseBody.map((dimension) => {
      let categories = [];
      let importanceScores = [];
      let currentScores = [];
      let futureScores = [];

      if (dimension.subDimensions && dimension.subDimensions.length > 0) {
        // Process subDimensions data
        dimension.subDimensions.forEach((subDimension) => {
          categories.push(subDimension.subDimensionName);
          importanceScores.push(subDimension.importantAverageValue);
          currentScores.push(subDimension.currentAverageValue);
          futureScores.push(subDimension.futureAverageValue);
        });
      } else {
        // If no subDimensions exist, use total averages
        categories = [dimension.dimensionName]; // Use dimension name as category
        importanceScores = [dimension.totalImportantAverage];
        currentScores = [dimension.totalCurrentAverage];
        futureScores = [dimension.totalFutureAverage];
      }

      return {
        dimensionName: dimension.dimensionName,
        totalCurrent: dimension.totalCurrentAverage,
        totalFuture: dimension.totalFutureAverage,
        totalImportance: dimension.totalImportantAverage,
        chartData: {
          labels: categories,
          datasets: [
            {
              label: "Current Score",
              data: currentScores,
              backgroundColor: "rgb(82,127,51)",
              borderColor: "rgb(82,127,51)",
              pointBackgroundColor: "rgb(82,127,51)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgb(82,127,51)",
              pointRadius: 6,
              pointHoverRadius: 8,
              fill: false,
            },
            {
              label: "Future Score",
              data: futureScores,
              backgroundColor: "rgb(254,190,0)",
              borderColor: "rgb(254,190,0)",
              pointBackgroundColor: "rgb(254,190,0)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgb(254,190,0)",
              pointRadius: 6,
              pointHoverRadius: 8,
              fill: false,
            },
            {
              label: "Importance Score",
              data: importanceScores,
              backgroundColor: "rgb(223,17,29)",
              borderColor: "rgb(223,17,29)",
              pointBackgroundColor: "rgb(223,17,29)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgb(223,17,29)",
              pointRadius: 6,
              pointHoverRadius: 8,
              fill: false,
            },
          ],
        },
      };
    });
  }, [responseBody]);

  const exportSummaryToExcel = (data, fileName = "Sub - Dimensions Radar charts") => {
    if (!data || !Array.isArray(data)) return;

    // Calculate totals
    let dimensionName = "";
    let totalCurrent = 0;
    let totalFuture = 0;
    let totalImportance = 0;

    data.forEach(dimension => {
      dimensionName += dimension.dimensionName
      totalCurrent += dimension.totalCurrent || 0;
      totalFuture += dimension.totalFuture || 0;
      totalImportance += dimension.totalImportance || 0;
    });

    const heading = ["Sub - Dimensions Radar charts"];
    const summaryRows = [
      heading,
      [], // empty row for spacing
      [`Total Current = ${totalCurrent.toFixed(2)}`],
      [`Total Future = ${totalFuture.toFixed(2)}`],
      [`Total Importance = ${totalImportance.toFixed(2)}`],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(summaryRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, fileName);
  };


  return (
    <>
      <div className="text-end">
        <button className="mb-3 dbtn px-3 py-2 text-white bg-primary rounded border-0 cursor-pointer me-3" onClick={() => exportSummaryToExcel(chartData)}>Download Excel</button>
      </div>
      <div>
        {chartData.length > 0 ? (
          chartData.map((data, index) => (
            <div key={index} className="chart-container">
              {/* Total Values Section */}


              {/* Radar Chart */}
              <DynamicRadarChart
                data={data}
                myhandleExport={myhandleExport}
                remark={remark}
              />
              <div className="d-flex justify-content-around rounded my-3 ">
                <div className="text-center ">
                  <h6 className="textfont12">Total Current</h6>
                  <h5 className="text-success textfont13">{data.totalCurrent.toFixed(2)}</h5>
                </div>
                <div className="text-center ">
                  <h6 className="textfont12">Total Future</h6>
                  <h5 className="text-warning textfont123">{data.totalFuture.toFixed(2)}</h5>
                </div>
                <div className="text-center">
                  <h6 className="textfont12">Total Importance</h6>
                  <h5 className="text-danger textfont13">{data.totalImportance.toFixed(2)}</h5>
                </div>
              </div>
              {/* <div className="summary-section">
              <p><strong>Total Current Score:</strong> {data.totalCurrent.toFixed(2)}</p>
              <p><strong>Total Future Score:</strong> {data.totalFuture.toFixed(2)}</p>
              <p><strong>Total Importance Score:</strong> {data.totalImportance.toFixed(2)}</p>
            </div> */}
            </div>

          ))
        ) : (
          <p>No data available</p>
        )}
      </div>
    </>

  );
};

export default SubDimensionCharts;
